import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from 'primereact/scrolltop';
import { Link } from 'react-router-dom';
import { PrevPurchaseOrderCreateForm } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/renewed_purchase_orders/{components}/PrevPurchaseOrderCreateForm';
import { NextPurchaseOrdersElement } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/renewed_purchase_orders/{components}/NextPurchaseOrdersElement';
import { PrevPurchaseOrdersElement } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/renewed_purchase_orders/{components}/PrevPurchaseOrdersElement';

export const EditRenewedPurchaseOrders = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`継続プロジェクト（費用）`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `プロジェクト（費用） - ${_t_!.name}`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders`,
        },
        {
          label: `プロジェクト（費用）詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}`,
        },
      ]),
    []
  );

  const { _po_ } = useCurrentPurchaseOrder();

  return (
    <>
      <WorkspaceLayout>
        <ScrollTop />

        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12 col-lg-9 mx-auto">
              <div className="card mb-4" id="basic-info">
                <div className="card-header d-flex align-items-center">
                  <div className="col-md-8">
                    <h5>継続プロジェクト（費用）</h5>
                  </div>
                </div>
                <div className="card-body pt-0 row">
                  <PrevPurchaseOrderCreateForm />

                  <NextPurchaseOrdersElement />

                  <PrevPurchaseOrdersElement />
                </div>
                <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                  <Link
                    to={`/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}`}
                    className="btn btn-outline-secondary"
                  >
                    案件詳細へ
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </WorkspaceLayout>
    </>
  );
};
